import { Faculty } from 'src/app/features/programs/shared/faculty.model';

export class BossDependence {
  nombre: String;
  fechaIniVigenciaSecre: String;
  fechaFinVigenciaSecre: String;
  facultadBean: Faculty;
}
